import MetalAEImage from "@/images/metal_ae@2x.png";
import MetalAPImage from "@/images/metal_ap@2x.png";
import MetalAQImage from "@/images/metal_aq@2x.png";
import MetalARImage from "@/images/metal_ar@2x.png";

export default [
  {
    shape: "圓框",
    name: "招財進寶",
    code: "AE",
    imagePath: MetalAEImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 16,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "圓框",
    name: "鴻福呈祥",
    code: "AP",
    imagePath: MetalAPImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 16,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "圓框",
    name: "雙魚荷花",
    code: "AQ",
    imagePath: MetalAQImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "圓框",
    name: "雙龍如意",
    code: "AR",
    imagePath: MetalARImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 5,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 7,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
];
